import { render, staticRenderFns } from "./CollectingShareForm.vue?vue&type=template&id=65428cb2"
import script from "./CollectingShareForm.vue?vue&type=script&lang=js"
export * from "./CollectingShareForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports